import { installerParams, installerSubParams } from '@/locales/localeParams'

export const installerJA: installerParams = [
  ') アップグレード - Solanaバージョンのアップデート/ダウングレード',
  ') バリデータ-の状態/ログを確認・または開始/停止',
  ') バリデータ-の設定情報',
  ') 鍵の設定',
  ') ステーキング',
  ') アンインストール',
  ') 終了',
]

export const installerSubJA: installerSubParams = [
  [],
  [
    ') バリデータ-の状態を確認',
    ') バリデーターのログを表示',
    ') バリデータ-を開始',
    ') バリデータ-を停止',
    ') バリデータ-を再起動 (fetch snapshot なし)',
    ') バリデータ-を再起動 (fetch snapshot あり)',
    ') メインメニューに戻る',
  ],
  [
    ') バリデータ-の設定を見る',
    ') バリデータ-情報を登録する',
    ') バリデータ-の鍵の パス/アドレス/残高 を見る',
    ') 現在の エポック/スロット を見る',
    ') バリデーターの Catchup 情報を見る',
    ') バリデーターのモニター情報を見る',
    ') メインメニューに戻る',
  ],
  [
    ') バリデーターの鍵をバックアップ',
    ') 鍵/ネットワークを設定する',
    ') メインメニューに戻る',
  ],
  [
    ') ステーキングを行う',
    ') アンステーキングを行う',
    ') メインメニューに戻る',
  ],
  [],
  [],
]
